export default {"src":"/_next/static/media/agreementKVKK.b2bd4073.svg","height":20,"width":20};